module.exports = __webpack_public_path__ + "static/media/0105_Medium.50035531.jpg";